import Button from "@app/sharedComponents/Button/Button";
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import InputText from "@app/sharedComponents/TextInput/TextInput";
import { ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { ScrollView } from "react-native";
import {RadioButton,Circle, Info} from '@app/sharedComponents/Icons/Icons';
import { useEffect, useRef, useState } from "react";
import ROUTE from "@app/navigationApp/routes";
import { formatIndianCurrency } from "@app/utils/utility";
import { LENDER_ID } from "@app/types/regix";
import { checkColor, REPAYMENT_COLLECTION_TYPE } from "@app/utils";
import AutodebitInfo from "./components/AutodebitInfo";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import { useAppSelector } from "@app/store/hooks";
import ChargesSheet from "./components/ChargesSheet";


const ShortfallRepay = ({navigation,route})=>{
    const {paymentAmount} = route?.params || {};
    const [repayOptionSelected, setRepayOptionSelected] = useState<string | null>(null);
    const ref = useRef(null);
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
    const lendingPartnerId = useAppSelector(state=>state.auth.creditDetails?.lendingPartnerId);
    const [selectedAmount,setSelectedAmount] = useState('');
    const [validationError, setValidationError] = useState('');
    const [bottomSheetType, setBottomSheetType] = useState('');
    const shortFallDetails = useAppSelector((state) => state.auth.shortFallDetails);
    const {shortfallAmount,chargesDue,principalOutstandingAmount,lenderId,recommendedAmount,minimumPayable,interestDue} = shortFallDetails;    
    useEffect(()=>{
            if(paymentAmount){
                setRepayOptionSelected('MANUAL_AMOUNT')
                setSelectedAmount(paymentAmount)
            }
        },[paymentAmount])
        
    const onInput = (value:string)=>{
        let formattedText = value.replace(/[^0-9]/g, '');
        if(formattedText.length>1 && formattedText[0] === '0'){
          formattedText = formattedText.slice(1);
        }
        setSelectedAmount(formattedText);
        if(formattedText<minimumPayable){
            setValidationError(`Amount must be greater than ₹${formatIndianCurrency(minimumPayable)}`);
        }
        else if(formattedText>principalOutstandingAmount  && formattedText>minimumPayable){
            setValidationError(`Amount should not be more than outstanding balance ₹${formatIndianCurrency(principalOutstandingAmount)}`);
        } else{
            setValidationError('')
        }
    }
    const onRepayOptionSelection = (option:string)=> {
        setValidationError('')
        setRepayOptionSelected(option)
        if(option === 'MANUAL_AMOUNT'){
            setSelectedAmount('')
        }else if(option === 'RECOMMENDED_AMOUNT'){
            setSelectedAmount(recommendedAmount)
        }else if(option === 'MINIMUM_AMOUNT'){
            setSelectedAmount(minimumPayable)
        }
    }

    const openBottomSheet = ()=>{
        if(chargesDue > 0 || interestDue>0 && ((lendingPartnerId?.toLowerCase() === LENDER_ID.TATA ||  lendingPartnerId?.toLowerCase() === LENDER_ID.DSP ))){
            setIsBottomSheetVisible(true);
            setBottomSheetType('AUTO_DEBIT_SHEET')
        }else{
            proceedToRepay();
        }
    }

    const openChargesDues = () => {
        setIsBottomSheetVisible(true);
        setBottomSheetType('CHARGES_SHEET')
    }

    const proceedToRepay = ()=>{
        if(isBottomSheetVisible){
            closeBottomSheet()
            setTimeout(()=>{
                navigation.navigate(ROUTE.CONFIRM_PAYMENT_DETAILS,{selectedAmount,paymentType:REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT})
            },700)
        }
        else{
            navigation.navigate(ROUTE.CONFIRM_PAYMENT_DETAILS,{selectedAmount,paymentType:REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT})
        }
       
    }

    const openLearnMore = ()=>{
        navigation.navigate(ROUTE.SHOTFALL_LEARN_MORE,{shortFallDetails})
    }

    const closeBottomSheet = () =>{
        setIsBottomSheetVisible(false);
        setTimeout(()=>{
            setBottomSheetType('')
        },400)
    }

    const goToTransactions = () =>{
        closeBottomSheet();
        navigation.navigate(ROUTE.TRANSACTION_SCREEN);
    }
    return(
        <ThemedView flex={1} backgroundColor="bg-surface-primary">
        <PageHeaders pageName={route?.name} label="Repay shortfall" navigation={navigation}/>
        <ScrollView contentContainerStyle={{flex: 1, backgroundColor: '#fff', }}>
            <ThemedView backgroundColor="bg-surface-primary" p="lg" borderBottomWidth={1} borderColor="border-primary">
                <ThemedView flexDirection="row" justifyContent="space-between" mb="md">
                    <ThemedText variant="b3r" color="text-secondary">Amount due</ThemedText>
                    <ThemedText variant="b3m" color="text-primary">₹{formatIndianCurrency(shortfallAmount)}</ThemedText>
                </ThemedView>
               {chargesDue>0 && lendingPartnerId?.toLowerCase()!==LENDER_ID.BAJAJ.toLowerCase() &&
                <ThemedView flexDirection="row" justifyContent="space-between" mb="md">
                    <ThemedView flexDirection="row" alignItems="center">
                        <ThemedText variant="b3r" color="text-secondary">Charges due  </ThemedText>
                        <ThemedPressable onPress={openChargesDues}><Info  size={16}/></ThemedPressable>
                    </ThemedView>
                    <ThemedText variant="b3m" color="text-primary">₹{formatIndianCurrency(chargesDue)}</ThemedText>
                </ThemedView>}
               {interestDue>0 && lendingPartnerId?.toLowerCase()!==LENDER_ID.BAJAJ.toLowerCase() &&
                <ThemedView flexDirection="row" justifyContent="space-between" mb="md">
                    <ThemedText variant="b3r" color="text-secondary">Interest due</ThemedText>
                    <ThemedText variant="b3m" color="text-primary">₹{formatIndianCurrency(interestDue)}</ThemedText>
                </ThemedView>}
                {
                (chargesDue > 0 || interestDue > 0) && lendingPartnerId?.toLowerCase()!==LENDER_ID.BAJAJ.toLowerCase() &&
                <>
                <ThemedView height={1} backgroundColor="border-secondary" mb="lg" mt="xs"/>
                <ThemedView flexDirection="row" justifyContent="space-between">
                    <ThemedText variant="b3s" color="text-primary">Minimum payable</ThemedText>
                    <ThemedText variant="b3s" color="text-primary">₹{formatIndianCurrency(minimumPayable)}</ThemedText>
                </ThemedView>
                </>
                }
            </ThemedView>
            <ThemedView px='lg' pt='2xl' flex={1}  backgroundColor="bg-surface-primary">
                <ThemedText variant="b2s" color="text-primary" mb='2xl'>
                Select amount for repayment
                </ThemedText>
                <ThemedPressable  onPress={()=>onRepayOptionSelection('MINIMUM_AMOUNT')} flexDirection="row" alignItems="center">
                {
                    repayOptionSelected==='MINIMUM_AMOUNT' ?
                    <RadioButton size={24} weight="fill" color={checkColor("#1434CB")}/> :
                    <Circle size={24}  color="#C0D1E7"/>
                }
                <ThemedText  variant={repayOptionSelected==='MINIMUM_AMOUNT' ? "b2s":"b2r"} color="text-primary" ml='md'>
                Pay minimum ₹{formatIndianCurrency(minimumPayable)}
                </ThemedText>
                </ThemedPressable>
                <ThemedView height={1} backgroundColor="border-secondary" mt='lg'/>
                <ThemedPressable flexDirection="row" py="lg" onPress={()=>onRepayOptionSelection('RECOMMENDED_AMOUNT')} >
                {
                    repayOptionSelected==='RECOMMENDED_AMOUNT'?
                    <RadioButton size={24} weight="fill" color={checkColor("#1434CB")}/> :
                    <Circle size={24}  color="#C0D1E7"/>
                }
                <ThemedView flex={1} ml='md'>
                    <ThemedView flexDirection="row" alignItems="center" mb='xs'>
                        <ThemedText  variant={repayOptionSelected==='RECOMMENDED_AMOUNT' ? "b2s":"b2r"} color="text-primary">
                        Pay ₹{formatIndianCurrency(recommendedAmount)}
                        </ThemedText>
                        <ThemedView px="sm" backgroundColor="bg-fill-emphasis-secondary" borderRadius="sm" ml="sm">
                            <ThemedText variant="b2r" color="text-primary" >Recommended</ThemedText>
                        </ThemedView>
                    </ThemedView>
                    <ThemedView flex={1} flexDirection="row" flexWrap="wrap" >
                        <ThemedText variant="b4r" color="text-primary">
                        We recommend reducing utilisation to 95% of credit limit.{' '}
                        </ThemedText>
                        <ThemedPressable onPress={openLearnMore} >
                            <ThemedText variant="b4s" color="text-action-primary">
                            Learn more
                            </ThemedText>
                        </ThemedPressable>
                    </ThemedView>
                </ThemedView>
               
                </ThemedPressable>
                <ThemedView height={1} backgroundColor="border-secondary" mt='lg'/>

                <ThemedPressable flexDirection="row"  pt="lg" onPress={()=>onRepayOptionSelection('MANUAL_AMOUNT')}>
                {
                    repayOptionSelected==='MANUAL_AMOUNT' ?
                    <RadioButton size={24} weight="fill" color={checkColor("#1434CB")}/> :
                    <Circle size={24}  color="#C0D1E7"/>
                }
                <ThemedView flex={1}>
                    <ThemedText variant={repayOptionSelected==='MANUAL_AMOUNT' ? "b2s":"b2r"} color="text-primary" ml='md' mb='lg'>
                    Enter other amount
                    </ThemedText>
                   
                </ThemedView>
                </ThemedPressable>
                {repayOptionSelected==='MANUAL_AMOUNT' &&
                <ThemedView ml="4xl" pb="lg">
                    <InputText
                        ref={ref}
                        keyboardType="number-pad"
                        label="Enter amount"
                        showLabel={true}
                        showAnimation
                        value={selectedAmount}
                        autoFocus={true}
                        onChangeText={onInput}
                        showErrorMessage={true}
                        hasError={validationError}
                    />
                </ThemedView>
                    }
            </ThemedView>
        </ScrollView>
        <ThemedView backgroundColor="bg-surface-primary" p="lg" pt="2xl" borderTopWidth={1} borderColor="border-primary">
            <Button label="Proceed to repay" size="MD" disabled={!(selectedAmount>0) || (Boolean(validationError))} handlePress={openBottomSheet}/>
        </ThemedView>
        <BottomSheetContainer
            isVisible={isBottomSheetVisible}
            close={closeBottomSheet}
            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
        >
            {bottomSheetType ==="CHARGES_SHEET" && <ChargesSheet chargesDue={chargesDue} goToTransactions={goToTransactions} closeBottomSheet={closeBottomSheet}/>}
            {bottomSheetType ==="AUTO_DEBIT_SHEET" && <AutodebitInfo chargesDue={chargesDue} interestDue={interestDue} selectedAmount={selectedAmount} onRepay={proceedToRepay}/>}
        </BottomSheetContainer>
        </ThemedView>
    )
}

export default ShortfallRepay;